module.exports = {
	"header": "Jon Ölmeskog joins Spotin as designer",
	"date": "2022/01/25",
	"imgSrc": "12.jpg",
	"imgAlt": "Jon Ölmeskog joins Spotin as designer",
	"ingress": "By: it-Karriär (in Swedish)",
	"externalLink": "https://it-karriar.se/jon-olmeskog-gar-in-med-designerroll-i-spotin/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/12/article.json
// module id = 83
// module chunks = 0